
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdfGenerator/selection2D",
      function () {
        return require("private-next-pages/pdfGenerator/selection2D/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdfGenerator/selection2D"])
      });
    }
  